import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home';
import Help from './components/Help';
import MetaDB from './components/MetaDB';
import Contribute from './components/Contribute';
import Tools from './components/Tools';
import AdminCenter from './components/AdminCenter';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import './custom.css'
import PlayerDetails from './components/features/players/PlayerDetails';
import SupporterDonate from './components/features/supporters/SupporterDonate';
import GameByID from './components/features/games/GameById';
import EditGameById from './components/features/games/EditGameById';
import { ConfirmProvider } from "material-ui-confirm";
import UpdateEventGames from './components/features/games/UpdateEventGames';
import EventsByGameSource from './components/features/games/EventsByGameSource';
import GamesByEventId from './components/features/games/GamesByEventId';

export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <ConfirmProvider>
                <Layout>
                    <Route exact path='/' component={Home} />
                    <Route path="*" element={Home} />
                    <Route exact path='/Help' component={Help} />
                    <AuthorizeRoute path='/EventGames/Update' component={UpdateEventGames} />
                    <AuthorizeRoute path='/EventGames/ByGameSource' component={EventsByGameSource} />
                    <Route path='/Players/Details' component={PlayerDetails} />
                    <Route path='/Games/GamesByEventID' component={GamesByEventId} />
                    <Route exact path='/Games/GameByID/:gameId' component={GameByID} />
                    <AuthorizeRoute exact path='/Games/EditGameById/:gameId' component={EditGameById} />
                    <AuthorizeRoute path='/MetaDB' component={MetaDB} />
                    <AuthorizeRoute path='/Contribute' component={Contribute} />
                    <AuthorizeRoute path='/Tools' component={Tools} />
                    <AuthorizeRoute path='/AdminCenter' component={AdminCenter} />
                    <AuthorizeRoute path='/SupporterDonate' component={SupporterDonate} />
                    <Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />
                </Layout>
            </ConfirmProvider>
        );
    }
}